<template>
  <main
    class="layout__default"
    :class="mainClass"
  >
    <slot />
  </main>
</template>

<script setup lang="ts">
useTokenSync()

const mainClass = useState('main-class', () => ref({}))
</script>

<style src="~layers/app/layouts/default.css" />
